/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Text, View } from "@aws-amplify/ui-react";
export default function EveryoneAgreesMobile(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="19px"
      direction="column"
      width="402px"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "EveryoneAgreesMobile")}
      {...rest}
    >
      <Flex
        padding="0px 0px 0px 0px"
        width="326.47px"
        height="339px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Group 1160463944")}
      >
        <View
          width="122.74px"
          height="126.64px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          position="absolute"
          top="212.36px"
          left="0px"
          border="0.65px SOLID rgba(225,225,225,1)"
          borderRadius="5.195441246032715px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "389 3")}
        >
          <Icon
            width="159px"
            height="106px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 158.99530029296875,
              height: 105.99686431884766,
            }}
            paths={[]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="16.3%"
            left="0%"
            right="-29.54%"
            {...getOverrideProps(overrides, "Vector763024546")}
          ></Icon>
          <Icon
            width="19.71px"
            height="14.35px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 19.712060928344727,
              height: 14.347073554992676,
            }}
            paths={[
              {
                d: "M6.46281 12.8306C11.9047 16.0923 19.7121 13.0772 19.7121 13.0772C19.7121 13.0772 18.6911 4.7752 13.2461 1.51739C7.80402 -1.74413 0 1.26723 0 1.26723C0 1.26723 1.02075 9.56908 6.46281 12.8306Z",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="58.05%"
            bottom="30.63%"
            left="13.52%"
            right="70.42%"
            {...getOverrideProps(overrides, "Vector763024547")}
          ></Icon>
          <Icon
            width="4.55px"
            height="4.55px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 4.548326015472412,
              height: 4.548323154449463,
            }}
            paths={[
              {
                d: "M2.27416 4.54832C3.53015 4.54832 4.54833 3.53015 4.54833 2.27416C4.54833 1.01817 3.53015 0 2.27416 0C1.01817 0 0 1.01817 0 2.27416C0 3.53015 1.01817 4.54832 2.27416 4.54832Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="28.33%"
            bottom="68.08%"
            left="50.91%"
            right="45.38%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024548")}
          ></Icon>
          <Icon
            width="5.12px"
            height="5.12px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 5.116825580596924,
              height: 5.116825580596924,
            }}
            paths={[
              {
                d: "M2.55841 5.11683C3.97138 5.11683 5.11683 3.97139 5.11683 2.55842C5.11683 1.14544 3.97138 0 2.55841 0C1.14544 0 0 1.14544 0 2.55842C0 3.97139 1.14544 5.11683 2.55841 5.11683Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="40.26%"
            bottom="55.7%"
            left="40.35%"
            right="55.48%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024549")}
          ></Icon>
          <Icon
            width="2.56px"
            height="2.56px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.558411121368408,
              height: 2.558411121368408,
            }}
            paths={[
              {
                d: "M1.27921 2.55841C1.98569 2.55841 2.55841 1.98569 2.55841 1.27921C2.55841 0.57272 1.98569 0 1.27921 0C0.57272 0 0 0.57272 0 1.27921C0 1.98569 0.57272 2.55841 1.27921 2.55841Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="69.17%"
            bottom="28.81%"
            left="97.88%"
            right="0.04%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024550")}
          ></Icon>
          <Icon
            width="3.7px"
            height="3.7px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.695404052734375,
              height: 3.695404052734375,
            }}
            paths={[
              {
                d: "M1.8477 3.6954C2.86816 3.6954 3.6954 2.86816 3.6954 1.8477C3.6954 0.827244 2.86816 0 1.8477 0C0.827244 0 0 0.827244 0 1.8477C0 2.86816 0.827244 3.6954 1.8477 3.6954Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="58.23%"
            bottom="38.85%"
            left="25.49%"
            right="71.5%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024551")}
          ></Icon>
          <Icon
            width="2.81px"
            height="2.81px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.8124501705169678,
              height: 2.8124501705169678,
            }}
            paths={[
              {
                d: "M1.40623 2.81245C2.18286 2.81245 2.81245 2.18286 2.81245 1.40623C2.81245 0.629588 2.18286 0 1.40623 0C0.629588 0 0 0.629588 0 1.40623C0 2.18286 0.629588 2.81245 1.40623 2.81245Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="44.21%"
            bottom="53.57%"
            left="49.47%"
            right="48.24%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024552")}
          ></Icon>
          <Icon
            width="3.13px"
            height="3.13px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.1269073486328125,
              height: 3.1269073486328125,
            }}
            paths={[
              {
                d: "M1.56345 3.12691C2.42693 3.12691 3.12691 2.42693 3.12691 1.56345C3.12691 0.699982 2.42693 0 1.56345 0C0.699982 0 0 0.699982 0 1.56345C0 2.42693 0.699982 3.12691 1.56345 3.12691Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="16.91%"
            bottom="80.62%"
            left="93.92%"
            right="3.54%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024553")}
          ></Icon>
          <Icon
            width="2.81px"
            height="2.81px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.4389081709505263,
              height: 3.4389081709523452,
            }}
            paths={[
              {
                d: "M1.40393 2.80786C2.1793 2.80786 2.80786 2.1793 2.80786 1.40393C2.80786 0.62856 2.1793 0 1.40393 0C0.62856 0 0 0.62856 0 1.40393C0 2.1793 0.62856 2.80786 1.40393 2.80786Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="30.19%"
            bottom="67.59%"
            left="36.85%"
            right="60.87%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024554")}
          ></Icon>
          <Icon
            width="3.74px"
            height="3.74px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.7353293895721436,
              height: 3.7353293895721436,
            }}
            paths={[
              {
                d: "M1.86766 3.73533C2.89915 3.73533 3.73533 2.89915 3.73533 1.86766C3.73533 0.836182 2.89915 0 1.86766 0C0.836182 0 0 0.836182 0 1.86766C0 2.89915 0.836182 3.73533 1.86766 3.73533Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="12.39%"
            bottom="84.66%"
            left="61.12%"
            right="35.84%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024555")}
          ></Icon>
          <Icon
            width="2.87px"
            height="2.3px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.87357497215271,
              height: 2.2987184524536133,
            }}
            paths={[
              {
                d: "M1.43679 2.29872C2.2303 2.29872 2.87357 1.78413 2.87357 1.14936C2.87357 0.514586 2.2303 0 1.43679 0C0.643272 0 0 0.514586 0 1.14936C0 1.78413 0.643272 2.29872 1.43679 2.29872Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="49.89%"
            bottom="48.3%"
            left="106.18%"
            right="-8.52%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024556")}
          ></Icon>
          <Icon
            width="5.84px"
            height="5.84px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 7.157360884044465,
              height: 7.157360884044465,
            }}
            paths={[
              {
                d: "M2.92198 5.84396C4.53575 5.84396 5.84396 4.53575 5.84396 2.92198C5.84396 1.30822 4.53575 0 2.92198 0C1.30822 0 0 1.30822 0 2.92198C0 4.53575 1.30822 5.84396 2.92198 5.84396Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="22.03%"
            bottom="73.36%"
            left="77.52%"
            right="17.72%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024557")}
          ></Icon>
          <Icon
            width="99.35px"
            height="36.9px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 99.3468017578125,
              height: 36.898921966552734,
            }}
            paths={[
              {
                d: "M96.7414 0L96.779 0C97.0016 3.15358 99.3468 3.20199 99.3468 3.20199C99.3468 3.20199 96.7606 3.25251 96.7606 6.89633C96.7606 3.25251 94.1745 3.20199 94.1745 3.20199C94.1745 3.20199 96.5188 3.15358 96.7414 0ZM2.27752 30.6573L2.31091 30.6573C2.50842 33.5114 4.58931 33.5554 4.58931 33.5554C4.58931 33.5554 2.29466 33.601 2.29466 36.8989C2.29466 33.601 0 33.5554 0 33.5554C0 33.5554 2.08001 33.5114 2.27752 30.6573Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="44.53%"
            bottom="26.34%"
            left="35.07%"
            right="-16.01%"
            {...getOverrideProps(overrides, "Vector763024558")}
          ></Icon>
          <Icon
            width="23.98px"
            height="23.98px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 23.98322296142578,
              height: 23.983362197875977,
            }}
            paths={[
              {
                d: "M0.000159214 11.9006L-2.73802 11.8797L-2.73806 11.8865L0.000159214 11.9006ZM12.0522 0.000156216L12.0661 -2.73806L12.066 -2.73806L12.0522 0.000156216ZM11.9919 23.9834L11.9853 26.7216L11.9919 26.7216L11.9919 23.9834ZM2.73833 11.9215C2.77718 6.82024 6.93708 2.71261 12.0384 2.73837L12.066 -2.73806C3.94558 -2.77907 -2.67617 3.75961 -2.73801 11.8797L2.73833 11.9215ZM12.0383 2.73837C17.1397 2.76428 21.2578 6.91368 21.2449 12.0149L26.7214 12.0287C26.7418 3.90821 20.1864 -2.69683 12.0661 -2.73806L12.0383 2.73837ZM21.2449 12.0149C21.2321 17.1163 17.0931 21.2451 11.9919 21.2451L11.9919 26.7216C20.1125 26.7216 26.701 20.149 26.7214 12.0287L21.2449 12.0149ZM11.9985 21.2451C10.7774 21.2422 9.56882 20.9983 8.44207 20.5275L6.33065 25.5806C8.12215 26.3292 10.0437 26.7169 11.9853 26.7216L11.9985 21.2451ZM8.44207 20.5275C7.31532 20.0567 6.29254 19.3682 5.43233 18.5015L1.54525 22.3593C2.91297 23.7374 4.53916 24.8321 6.33065 25.5806L8.44207 20.5275ZM5.43233 18.5015C4.57211 17.6347 3.89136 16.6068 3.42909 15.4765L-1.63985 17.5497C-0.904841 19.3468 0.177525 20.9812 1.54525 22.3593L5.43233 18.5015ZM3.42909 15.4765C2.96681 14.3462 2.73209 13.1358 2.73838 11.9147L-2.73806 11.8865C-2.74805 13.8281 -2.37485 15.7526 -1.63985 17.5497L3.42909 15.4765Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
              {
                d: "M0.000159214 11.9006C0.0505077 5.28993 5.44133 -0.0332328 12.0522 0.000156216C18.663 0.0337219 23.9998 5.41094 23.9832 12.0218C23.9666 18.6326 18.6028 23.9834 11.9919 23.9834C10.4106 23.9795 8.84548 23.6637 7.38636 23.0541C5.92724 22.4444 4.60276 21.5528 3.48879 20.4304C2.37482 19.3079 1.49326 17.9768 0.894621 16.5131C0.29598 15.0494 -0.00797944 13.482 0.000159214 11.9006Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="18.27%"
            bottom="62.79%"
            left="58.02%"
            right="22.44%"
            {...getOverrideProps(overrides, "Vector763024559")}
          ></Icon>
          <Icon
            width="47.97px"
            height="17.99px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 47.966400146484375,
              height: 17.987491607666016,
            }}
            paths={[
              {
                d: "M0 14.9896L-2.73826 14.9896L-2.73824 14.9974L0 14.9896ZM0 11.9916L-2.73825 11.9836L-2.73825 11.9916L0 11.9916ZM11.9916 0L11.9916 -2.73826L11.9836 -2.73824L11.9916 0ZM35.9748 0L35.9828 -2.73825L35.9748 -2.73825L35.9748 0ZM47.9664 11.9916L50.7047 11.9916L50.7046 11.9836L47.9664 11.9916ZM47.9664 14.9896L50.7047 14.9974L50.7047 14.9896L47.9664 14.9896ZM44.9685 17.9875L44.9685 20.7258L44.9767 20.7257L44.9685 17.9875ZM2.99794 17.9875L2.98975 20.7257L2.99794 20.7257L2.99794 17.9875ZM2.73825 14.9896L2.73825 11.9916L-2.73825 11.9916L-2.73825 14.9896L2.73825 14.9896ZM2.73824 11.9996C2.75325 6.89092 6.89092 2.75325 11.9996 2.73824L11.9836 -2.73824C3.86281 -2.71438 -2.71438 3.86281 -2.73824 11.9836L2.73824 11.9996ZM11.9916 2.73825L35.9748 2.73825L35.9748 -2.73825L11.9916 -2.73825L11.9916 2.73825ZM35.9668 2.73824C41.0755 2.75325 45.2132 6.89092 45.2282 11.9996L50.7046 11.9836C50.6808 3.86282 44.1036 -2.71438 35.9828 -2.73824L35.9668 2.73824ZM45.2281 11.9916L45.2281 14.9896L50.7047 14.9896L50.7047 11.9916L45.2281 11.9916ZM45.2282 14.9817C45.2277 15.129 45.1084 15.2488 44.9603 15.2493L44.9767 20.7257C48.136 20.7163 50.6955 18.1576 50.7046 14.9974L45.2282 14.9817ZM44.9685 15.2492L2.99794 15.2492L2.99794 20.7257L44.9685 20.7257L44.9685 15.2492ZM3.00614 15.2493C2.85803 15.2488 2.73867 15.129 2.73824 14.9817L-2.73824 14.9974C-2.72913 18.1576 -0.169597 20.7163 2.98975 20.7257L3.00614 15.2493Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
              {
                d: "M0 14.9896L0 11.9916C0.0194328 5.37687 5.37687 0.0194328 11.9916 0L35.9748 0C42.5895 0.0194328 47.947 5.37687 47.9664 11.9916L47.9664 14.9896C47.9616 16.6433 46.6222 17.9825 44.9685 17.9875L2.99794 17.9875C1.34422 17.9825 0.00476986 16.6433 0 14.9896Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="46.61%"
            bottom="39.19%"
            left="48.25%"
            right="12.67%"
            {...getOverrideProps(overrides, "Vector763024560")}
          ></Icon>
          <Icon
            width="30.7px"
            height="52.95px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 30.698453903198242,
              height: 52.948081970214844,
            }}
            paths={[
              {
                d: "M9.58338 1.93624C10.6527 0.866883 10.6527 -0.866883 9.58338 -1.93624C8.51403 -3.00559 6.78026 -3.00559 5.71091 -1.93624L9.58338 1.93624ZM2.42044 5.2267L0.484201 3.29047C-0.0293215 3.80399 -0.317815 4.50047 -0.317815 5.2267C-0.317815 5.95293 -0.0293213 6.64942 0.484201 7.16294L2.42044 5.2267ZM5.71091 12.3896C6.78026 13.459 8.51403 13.459 9.58338 12.3896C10.6527 11.3203 10.6527 9.58652 9.58338 8.51717L5.71091 12.3896ZM25.2635 -1.93624C24.1941 -3.00559 22.4604 -3.00559 21.391 -1.93624C20.3217 -0.866883 20.3217 0.866883 21.391 1.93624L25.2635 -1.93624ZM28.554 5.2267L30.4902 7.16294C31.0037 6.64942 31.2922 5.95293 31.2922 5.2267C31.2922 4.50047 31.0037 3.80399 30.4902 3.29047L28.554 5.2267ZM21.391 8.51717C20.3217 9.58652 20.3217 11.3203 21.391 12.3896C22.4604 13.459 24.1941 13.459 25.2635 12.3896L21.391 8.51717ZM0 22.5379C-1.5123 22.5379 -2.73825 23.7639 -2.73825 25.2762C-2.73825 26.7885 -1.5123 28.0144 0 28.0144L0 22.5379ZM30.6985 28.0144C32.2108 28.0144 33.4367 26.7885 33.4367 25.2762C33.4367 23.7639 32.2108 22.5379 30.6985 22.5379L30.6985 28.0144ZM0 36.3739C-1.5123 36.3739 -2.73825 37.5998 -2.73825 39.1121C-2.73825 40.6244 -1.5123 41.8504 0 41.8504L0 36.3739ZM30.6985 41.8504C32.2108 41.8504 33.4367 40.6244 33.4367 39.1121C33.4367 37.5998 32.2108 36.3739 30.6985 36.3739L30.6985 41.8504ZM0 50.2098C-1.5123 50.2098 -2.73825 51.4358 -2.73825 52.9481C-2.73825 54.4604 -1.5123 55.6863 0 55.6863L0 50.2098ZM30.6985 55.6863C32.2108 55.6863 33.4367 54.4604 33.4367 52.9481C33.4367 51.4358 32.2108 50.2098 30.6985 50.2098L30.6985 55.6863ZM5.71091 -1.93624L0.484201 3.29047L4.35667 7.16294L9.58338 1.93624L5.71091 -1.93624ZM0.484201 7.16294L5.71091 12.3896L9.58338 8.51717L4.35667 3.29047L0.484201 7.16294ZM21.391 1.93624L26.6177 7.16294L30.4902 3.29047L25.2635 -1.93624L21.391 1.93624ZM26.6177 3.29047L21.391 8.51717L25.2635 12.3896L30.4902 7.16294L26.6177 3.29047ZM0 28.0144L30.6985 28.0144L30.6985 22.5379L0 22.5379L0 28.0144ZM0 41.8504L30.6985 41.8504L30.6985 36.3739L0 36.3739L0 41.8504ZM0 55.6863L30.6985 55.6863L30.6985 50.2098L0 50.2098L0 55.6863Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="18.32%"
            bottom="39.87%"
            left="12.85%"
            right="62.14%"
            {...getOverrideProps(overrides, "Vector763024561")}
          ></Icon>
          <Flex
            gap="3.2758734226226807px"
            direction="column"
            width="100.41px"
            height="25.88px"
            justifyContent="space-between"
            alignItems="center"
            overflow="hidden"
            position="absolute"
            top="71.16%"
            bottom="8.4%"
            left="9.7%"
            right="8.49%"
            border="0.33px SOLID rgba(203,163,58,1)"
            borderRadius="1.3103493452072144px"
            padding="4.586222916841507px 7.958813458681107px 4.586222916841507px 7.958813458681107px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 427318909763024562")}
          >
            <Flex
              gap="2.2931113243103027px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318911763024563")}
            >
              <Text
                fontFamily="Inter"
                fontSize="10.810383796691895px"
                fontWeight="700"
                color="rgba(0,0,0,1)"
                lineHeight="16.215576171875px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="77%"
                {...getOverrideProps(overrides, "77%")}
              ></Text>
              <Flex
                gap="3.2758734226226807px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318934763024565")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="6.551746845245361px"
                  fontWeight="600"
                  color="rgba(0,0,0,1)"
                  lineHeight="7.108645439147949px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Match"
                  {...getOverrideProps(overrides, "Match763024566")}
                ></Text>
                <Flex
                  gap="3.2758734226226807px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  borderRadius="2.2931113243103027px"
                  padding="0.6551746726036072px 2.6206986904144287px 0.6551746726036072px 2.6206986904144287px"
                  backgroundColor="rgba(203,163,58,1)"
                  {...getOverrideProps(overrides, "Frame 427318910763024567")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="6.551746845245361px"
                    fontWeight="600"
                    color="rgba(255,255,255,1)"
                    lineHeight="7.108645439147949px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Good"
                    {...getOverrideProps(overrides, "Good")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </View>
        <View
          width="122.74px"
          height="126.64px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          position="absolute"
          top="212.36px"
          left="137.68px"
          border="0.65px SOLID rgba(225,225,225,1)"
          borderRadius="5.195441246032715px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "389 4")}
        >
          <Icon
            width="159px"
            height="106px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 158.99530029296875,
              height: 105.99686431884766,
            }}
            paths={[]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="16.3%"
            left="0%"
            right="-29.54%"
            {...getOverrideProps(overrides, "Vector763024570")}
          ></Icon>
          <Icon
            width="19.71px"
            height="14.35px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 19.712060928344727,
              height: 14.347073554992676,
            }}
            paths={[
              {
                d: "M6.46281 12.8306C11.9047 16.0923 19.7121 13.0772 19.7121 13.0772C19.7121 13.0772 18.6911 4.7752 13.2461 1.51739C7.80402 -1.74413 0 1.26723 0 1.26723C0 1.26723 1.02075 9.56908 6.46281 12.8306Z",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="58.05%"
            bottom="30.63%"
            left="13.52%"
            right="70.42%"
            {...getOverrideProps(overrides, "Vector763024571")}
          ></Icon>
          <Icon
            width="4.55px"
            height="4.55px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 4.548326015472412,
              height: 4.548323154449463,
            }}
            paths={[
              {
                d: "M2.27416 4.54832C3.53015 4.54832 4.54833 3.53015 4.54833 2.27416C4.54833 1.01817 3.53015 0 2.27416 0C1.01817 0 0 1.01817 0 2.27416C0 3.53015 1.01817 4.54832 2.27416 4.54832Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="28.33%"
            bottom="68.08%"
            left="50.91%"
            right="45.38%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024572")}
          ></Icon>
          <Icon
            width="5.12px"
            height="5.12px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 5.116825580596924,
              height: 5.116825580596924,
            }}
            paths={[
              {
                d: "M2.55841 5.11683C3.97138 5.11683 5.11683 3.97139 5.11683 2.55842C5.11683 1.14544 3.97138 0 2.55841 0C1.14544 0 0 1.14544 0 2.55842C0 3.97139 1.14544 5.11683 2.55841 5.11683Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="40.26%"
            bottom="55.7%"
            left="40.35%"
            right="55.48%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024573")}
          ></Icon>
          <Icon
            width="2.56px"
            height="2.56px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.558411121368408,
              height: 2.558411121368408,
            }}
            paths={[
              {
                d: "M1.27921 2.55841C1.98569 2.55841 2.55841 1.98569 2.55841 1.27921C2.55841 0.57272 1.98569 0 1.27921 0C0.57272 0 0 0.57272 0 1.27921C0 1.98569 0.57272 2.55841 1.27921 2.55841Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="69.17%"
            bottom="28.81%"
            left="97.88%"
            right="0.04%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024574")}
          ></Icon>
          <Icon
            width="3.7px"
            height="3.7px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.695404052734375,
              height: 3.695404052734375,
            }}
            paths={[
              {
                d: "M1.8477 3.6954C2.86816 3.6954 3.6954 2.86816 3.6954 1.8477C3.6954 0.827244 2.86816 0 1.8477 0C0.827244 0 0 0.827244 0 1.8477C0 2.86816 0.827244 3.6954 1.8477 3.6954Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="58.23%"
            bottom="38.85%"
            left="25.49%"
            right="71.5%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024575")}
          ></Icon>
          <Icon
            width="2.81px"
            height="2.81px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.8124501705169678,
              height: 2.8124501705169678,
            }}
            paths={[
              {
                d: "M1.40623 2.81245C2.18286 2.81245 2.81245 2.18286 2.81245 1.40623C2.81245 0.629588 2.18286 0 1.40623 0C0.629588 0 0 0.629588 0 1.40623C0 2.18286 0.629588 2.81245 1.40623 2.81245Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="44.21%"
            bottom="53.57%"
            left="49.47%"
            right="48.24%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024576")}
          ></Icon>
          <Icon
            width="3.13px"
            height="3.13px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.1269073486328125,
              height: 3.1269073486328125,
            }}
            paths={[
              {
                d: "M1.56345 3.12691C2.42693 3.12691 3.12691 2.42693 3.12691 1.56345C3.12691 0.699982 2.42693 0 1.56345 0C0.699982 0 0 0.699982 0 1.56345C0 2.42693 0.699982 3.12691 1.56345 3.12691Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="16.91%"
            bottom="80.62%"
            left="93.92%"
            right="3.54%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024577")}
          ></Icon>
          <Icon
            width="2.81px"
            height="2.81px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.4389081709505263,
              height: 3.4389081709523452,
            }}
            paths={[
              {
                d: "M1.40393 2.80786C2.1793 2.80786 2.80786 2.1793 2.80786 1.40393C2.80786 0.62856 2.1793 0 1.40393 0C0.62856 0 0 0.62856 0 1.40393C0 2.1793 0.62856 2.80786 1.40393 2.80786Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="30.19%"
            bottom="67.59%"
            left="36.85%"
            right="60.87%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024578")}
          ></Icon>
          <Icon
            width="3.74px"
            height="3.74px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.7353293895721436,
              height: 3.7353293895721436,
            }}
            paths={[
              {
                d: "M1.86766 3.73533C2.89915 3.73533 3.73533 2.89915 3.73533 1.86766C3.73533 0.836182 2.89915 0 1.86766 0C0.836182 0 0 0.836182 0 1.86766C0 2.89915 0.836182 3.73533 1.86766 3.73533Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="12.39%"
            bottom="84.66%"
            left="61.12%"
            right="35.84%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024579")}
          ></Icon>
          <Icon
            width="2.87px"
            height="2.3px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.87357497215271,
              height: 2.2987184524536133,
            }}
            paths={[
              {
                d: "M1.43679 2.29872C2.2303 2.29872 2.87357 1.78413 2.87357 1.14936C2.87357 0.514586 2.2303 0 1.43679 0C0.643272 0 0 0.514586 0 1.14936C0 1.78413 0.643272 2.29872 1.43679 2.29872Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="49.89%"
            bottom="48.3%"
            left="106.18%"
            right="-8.52%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024580")}
          ></Icon>
          <Icon
            width="5.84px"
            height="5.84px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 7.157360884044465,
              height: 7.157360884044465,
            }}
            paths={[
              {
                d: "M2.92198 5.84396C4.53575 5.84396 5.84396 4.53575 5.84396 2.92198C5.84396 1.30822 4.53575 0 2.92198 0C1.30822 0 0 1.30822 0 2.92198C0 4.53575 1.30822 5.84396 2.92198 5.84396Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="22.03%"
            bottom="73.36%"
            left="77.52%"
            right="17.72%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024581")}
          ></Icon>
          <Icon
            width="99.35px"
            height="36.9px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 99.3468017578125,
              height: 36.898921966552734,
            }}
            paths={[
              {
                d: "M96.7414 0L96.779 0C97.0016 3.15358 99.3468 3.20199 99.3468 3.20199C99.3468 3.20199 96.7606 3.25251 96.7606 6.89633C96.7606 3.25251 94.1745 3.20199 94.1745 3.20199C94.1745 3.20199 96.5188 3.15358 96.7414 0ZM2.27752 30.6573L2.31091 30.6573C2.50842 33.5114 4.58931 33.5554 4.58931 33.5554C4.58931 33.5554 2.29466 33.601 2.29466 36.8989C2.29466 33.601 0 33.5554 0 33.5554C0 33.5554 2.08001 33.5114 2.27752 30.6573Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="44.53%"
            bottom="26.34%"
            left="35.07%"
            right="-16.01%"
            {...getOverrideProps(overrides, "Vector763024582")}
          ></Icon>
          <Icon
            width="23.98px"
            height="23.98px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 23.98322296142578,
              height: 23.983362197875977,
            }}
            paths={[
              {
                d: "M0.000159214 11.9006L-2.73802 11.8797L-2.73806 11.8865L0.000159214 11.9006ZM12.0522 0.000156216L12.0661 -2.73806L12.066 -2.73806L12.0522 0.000156216ZM11.9919 23.9834L11.9853 26.7216L11.9919 26.7216L11.9919 23.9834ZM2.73833 11.9215C2.77718 6.82024 6.93708 2.71261 12.0384 2.73837L12.066 -2.73806C3.94558 -2.77907 -2.67617 3.75961 -2.73801 11.8797L2.73833 11.9215ZM12.0383 2.73837C17.1397 2.76428 21.2578 6.91368 21.2449 12.0149L26.7214 12.0287C26.7418 3.90821 20.1864 -2.69683 12.0661 -2.73806L12.0383 2.73837ZM21.2449 12.0149C21.2321 17.1163 17.0931 21.2451 11.9919 21.2451L11.9919 26.7216C20.1125 26.7216 26.701 20.149 26.7214 12.0287L21.2449 12.0149ZM11.9985 21.2451C10.7774 21.2422 9.56882 20.9983 8.44207 20.5275L6.33065 25.5806C8.12215 26.3292 10.0437 26.7169 11.9853 26.7216L11.9985 21.2451ZM8.44207 20.5275C7.31532 20.0567 6.29254 19.3682 5.43233 18.5015L1.54525 22.3593C2.91297 23.7374 4.53916 24.8321 6.33065 25.5806L8.44207 20.5275ZM5.43233 18.5015C4.57211 17.6347 3.89136 16.6068 3.42909 15.4765L-1.63985 17.5497C-0.904841 19.3468 0.177525 20.9812 1.54525 22.3593L5.43233 18.5015ZM3.42909 15.4765C2.96681 14.3462 2.73209 13.1358 2.73838 11.9147L-2.73806 11.8865C-2.74805 13.8281 -2.37485 15.7526 -1.63985 17.5497L3.42909 15.4765Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
              {
                d: "M0.000159214 11.9006C0.0505077 5.28993 5.44133 -0.0332328 12.0522 0.000156216C18.663 0.0337219 23.9998 5.41094 23.9832 12.0218C23.9666 18.6326 18.6028 23.9834 11.9919 23.9834C10.4106 23.9795 8.84548 23.6637 7.38636 23.0541C5.92724 22.4444 4.60276 21.5528 3.48879 20.4304C2.37482 19.3079 1.49326 17.9768 0.894621 16.5131C0.29598 15.0494 -0.00797944 13.482 0.000159214 11.9006Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="18.27%"
            bottom="62.79%"
            left="58.02%"
            right="22.44%"
            {...getOverrideProps(overrides, "Vector763024583")}
          ></Icon>
          <Icon
            width="47.97px"
            height="17.99px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 47.966400146484375,
              height: 17.987491607666016,
            }}
            paths={[
              {
                d: "M0 14.9896L-2.73826 14.9896L-2.73824 14.9974L0 14.9896ZM0 11.9916L-2.73825 11.9836L-2.73825 11.9916L0 11.9916ZM11.9916 0L11.9916 -2.73826L11.9836 -2.73824L11.9916 0ZM35.9748 0L35.9828 -2.73825L35.9748 -2.73825L35.9748 0ZM47.9664 11.9916L50.7047 11.9916L50.7046 11.9836L47.9664 11.9916ZM47.9664 14.9896L50.7047 14.9974L50.7047 14.9896L47.9664 14.9896ZM44.9685 17.9875L44.9685 20.7258L44.9767 20.7257L44.9685 17.9875ZM2.99794 17.9875L2.98975 20.7257L2.99794 20.7257L2.99794 17.9875ZM2.73825 14.9896L2.73825 11.9916L-2.73825 11.9916L-2.73825 14.9896L2.73825 14.9896ZM2.73824 11.9996C2.75325 6.89092 6.89092 2.75325 11.9996 2.73824L11.9836 -2.73824C3.86281 -2.71438 -2.71438 3.86281 -2.73824 11.9836L2.73824 11.9996ZM11.9916 2.73825L35.9748 2.73825L35.9748 -2.73825L11.9916 -2.73825L11.9916 2.73825ZM35.9668 2.73824C41.0755 2.75325 45.2132 6.89092 45.2282 11.9996L50.7046 11.9836C50.6808 3.86282 44.1036 -2.71438 35.9828 -2.73824L35.9668 2.73824ZM45.2281 11.9916L45.2281 14.9896L50.7047 14.9896L50.7047 11.9916L45.2281 11.9916ZM45.2282 14.9817C45.2277 15.129 45.1084 15.2488 44.9603 15.2493L44.9767 20.7257C48.136 20.7163 50.6955 18.1576 50.7046 14.9974L45.2282 14.9817ZM44.9685 15.2492L2.99794 15.2492L2.99794 20.7257L44.9685 20.7257L44.9685 15.2492ZM3.00614 15.2493C2.85803 15.2488 2.73867 15.129 2.73824 14.9817L-2.73824 14.9974C-2.72913 18.1576 -0.169597 20.7163 2.98975 20.7257L3.00614 15.2493Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
              {
                d: "M0 14.9896L0 11.9916C0.0194328 5.37687 5.37687 0.0194328 11.9916 0L35.9748 0C42.5895 0.0194328 47.947 5.37687 47.9664 11.9916L47.9664 14.9896C47.9616 16.6433 46.6222 17.9825 44.9685 17.9875L2.99794 17.9875C1.34422 17.9825 0.00476986 16.6433 0 14.9896Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="46.61%"
            bottom="39.19%"
            left="48.26%"
            right="12.67%"
            {...getOverrideProps(overrides, "Vector763024584")}
          ></Icon>
          <Icon
            width="30.7px"
            height="52.95px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 30.698453903198242,
              height: 52.948081970214844,
            }}
            paths={[
              {
                d: "M9.58338 1.93624C10.6527 0.866883 10.6527 -0.866883 9.58338 -1.93624C8.51403 -3.00559 6.78026 -3.00559 5.71091 -1.93624L9.58338 1.93624ZM2.42044 5.2267L0.484201 3.29047C-0.0293215 3.80399 -0.317815 4.50047 -0.317815 5.2267C-0.317815 5.95293 -0.0293213 6.64942 0.484201 7.16294L2.42044 5.2267ZM5.71091 12.3896C6.78026 13.459 8.51403 13.459 9.58338 12.3896C10.6527 11.3203 10.6527 9.58652 9.58338 8.51717L5.71091 12.3896ZM25.2635 -1.93624C24.1941 -3.00559 22.4604 -3.00559 21.391 -1.93624C20.3217 -0.866883 20.3217 0.866883 21.391 1.93624L25.2635 -1.93624ZM28.554 5.2267L30.4902 7.16294C31.0037 6.64942 31.2922 5.95293 31.2922 5.2267C31.2922 4.50047 31.0037 3.80399 30.4902 3.29047L28.554 5.2267ZM21.391 8.51717C20.3217 9.58652 20.3217 11.3203 21.391 12.3896C22.4604 13.459 24.1941 13.459 25.2635 12.3896L21.391 8.51717ZM0 22.5379C-1.5123 22.5379 -2.73825 23.7639 -2.73825 25.2762C-2.73825 26.7885 -1.5123 28.0144 0 28.0144L0 22.5379ZM30.6985 28.0144C32.2108 28.0144 33.4367 26.7885 33.4367 25.2762C33.4367 23.7639 32.2108 22.5379 30.6985 22.5379L30.6985 28.0144ZM0 36.3739C-1.5123 36.3739 -2.73825 37.5998 -2.73825 39.1121C-2.73825 40.6244 -1.5123 41.8504 0 41.8504L0 36.3739ZM30.6985 41.8504C32.2108 41.8504 33.4367 40.6244 33.4367 39.1121C33.4367 37.5998 32.2108 36.3739 30.6985 36.3739L30.6985 41.8504ZM0 50.2098C-1.5123 50.2098 -2.73825 51.4358 -2.73825 52.9481C-2.73825 54.4604 -1.5123 55.6863 0 55.6863L0 50.2098ZM30.6985 55.6863C32.2108 55.6863 33.4367 54.4604 33.4367 52.9481C33.4367 51.4358 32.2108 50.2098 30.6985 50.2098L30.6985 55.6863ZM5.71091 -1.93624L0.484201 3.29047L4.35667 7.16294L9.58338 1.93624L5.71091 -1.93624ZM0.484201 7.16294L5.71091 12.3896L9.58338 8.51717L4.35667 3.29047L0.484201 7.16294ZM21.391 1.93624L26.6177 7.16294L30.4902 3.29047L25.2635 -1.93624L21.391 1.93624ZM26.6177 3.29047L21.391 8.51717L25.2635 12.3896L30.4902 7.16294L26.6177 3.29047ZM0 28.0144L30.6985 28.0144L30.6985 22.5379L0 22.5379L0 28.0144ZM0 41.8504L30.6985 41.8504L30.6985 36.3739L0 36.3739L0 41.8504ZM0 55.6863L30.6985 55.6863L30.6985 50.2098L0 50.2098L0 55.6863Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="18.32%"
            bottom="39.87%"
            left="12.85%"
            right="62.14%"
            {...getOverrideProps(overrides, "Vector763024585")}
          ></Icon>
          <Flex
            gap="3.2758734226226807px"
            direction="column"
            width="100.41px"
            height="25.88px"
            justifyContent="space-between"
            alignItems="center"
            overflow="hidden"
            position="absolute"
            top="71.16%"
            bottom="8.4%"
            left="9.7%"
            right="8.49%"
            border="0.33px SOLID rgba(71,160,80,1)"
            borderRadius="1.3103493452072144px"
            padding="4.586222916841507px 7.958813458681107px 4.586222916841507px 7.958813458681107px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 427318909763024586")}
          >
            <Flex
              gap="2.2931113243103027px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318911763024587")}
            >
              <Text
                fontFamily="Inter"
                fontSize="10.810383796691895px"
                fontWeight="700"
                color="rgba(0,0,0,1)"
                lineHeight="16.215576171875px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="80%"
                {...getOverrideProps(overrides, "80%")}
              ></Text>
              <Flex
                gap="3.2758734226226807px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318934763024589")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="6.551746845245361px"
                  fontWeight="600"
                  color="rgba(0,0,0,1)"
                  lineHeight="7.108645439147949px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Match"
                  {...getOverrideProps(overrides, "Match763024590")}
                ></Text>
                <Flex
                  gap="3.2758734226226807px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  borderRadius="2.2931113243103027px"
                  padding="0.6551746726036072px 2.6206986904144287px 0.6551746726036072px 2.6206986904144287px"
                  backgroundColor="rgba(71,160,80,1)"
                  {...getOverrideProps(overrides, "Frame 427318910763024591")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="6.551746845245361px"
                    fontWeight="600"
                    color="rgba(255,255,255,1)"
                    lineHeight="7.108645439147949px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Great"
                    {...getOverrideProps(overrides, "Great763024592")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </View>
        <View
          width="166.9px"
          height="166.2px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          position="absolute"
          top="27.92px"
          left="137.03px"
          border="0.88px SOLID rgba(71,160,80,1)"
          boxShadow="0px 0px 133.93197631835938px rgba(0, 0, 0, 0.10000000149011612)"
          borderRadius="7.064700603485107px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "389 2")}
        >
          <Icon
            width="216.2px"
            height="144.13px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 216.19996643066406,
              height: 144.13331604003906,
            }}
            paths={[]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="13.28%"
            left="0%"
            right="-29.54%"
            {...getOverrideProps(overrides, "Vector763024594")}
          ></Icon>
          <Icon
            width="26.8px"
            height="19.51px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 26.804231643676758,
              height: 19.50898551940918,
            }}
            paths={[
              {
                d: "M8.78805 17.4469C16.1879 21.8821 26.8042 17.7823 26.8042 17.7823C26.8042 17.7823 25.416 6.49327 18.0119 2.06333C10.6118 -2.37165 0 1.72317 0 1.72317C0 1.72317 1.388 13.0119 8.78805 17.4469Z",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="60.14%"
            bottom="28.12%"
            left="13.52%"
            right="70.42%"
            {...getOverrideProps(overrides, "Vector763024595")}
          ></Icon>
          <Icon
            width="6.18px"
            height="6.18px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 6.184761047363281,
              height: 6.184756755828857,
            }}
            paths={[
              {
                d: "M3.09238 6.18476C4.80025 6.18476 6.18476 4.80025 6.18476 3.09238C6.18476 1.3845 4.80025 0 3.09238 0C1.3845 0 0 1.3845 0 3.09238C0 4.80025 1.3845 6.18476 3.09238 6.18476Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="29.35%"
            bottom="66.93%"
            left="50.91%"
            right="45.38%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024596")}
          ></Icon>
          <Icon
            width="6.96px"
            height="6.96px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 6.957799911499023,
              height: 6.957799911499023,
            }}
            paths={[
              {
                d: "M3.4789 6.9578C5.40024 6.9578 6.9578 5.40025 6.9578 3.4789C6.9578 1.55756 5.40024 0 3.4789 0C1.55755 0 0 1.55756 0 3.4789C0 5.40025 1.55755 6.9578 3.4789 6.9578Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="41.72%"
            bottom="54.1%"
            left="40.35%"
            right="55.48%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024597")}
          ></Icon>
          <Icon
            width="3.48px"
            height="3.48px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.4788978099823,
              height: 3.4788978099823,
            }}
            paths={[
              {
                d: "M1.73945 3.4789C2.70012 3.4789 3.4789 2.70012 3.4789 1.73945C3.4789 0.778778 2.70012 0 1.73945 0C0.778778 0 0 0.778778 0 1.73945C0 2.70012 0.778778 3.4789 1.73945 3.4789Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="71.67%"
            bottom="26.24%"
            left="97.88%"
            right="0.04%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024598")}
          ></Icon>
          <Icon
            width="5.02px"
            height="5.02px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 5.024967670440674,
              height: 5.024967670440674,
            }}
            paths={[
              {
                d: "M2.51248 5.02497C3.90009 5.02497 5.02497 3.90009 5.02497 2.51248C5.02497 1.12488 3.90009 0 2.51248 0C1.12488 0 0 1.12488 0 2.51248C0 3.90009 1.12488 5.02497 2.51248 5.02497Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="60.33%"
            bottom="36.64%"
            left="25.49%"
            right="71.5%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024599")}
          ></Icon>
          <Icon
            width="3.82px"
            height="3.82px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.8243370056152344,
              height: 3.8243370056152344,
            }}
            paths={[
              {
                d: "M1.91217 3.82434C2.96823 3.82434 3.82434 2.96823 3.82434 1.91217C3.82434 0.856107 2.96823 0 1.91217 0C0.856107 0 0 0.856107 0 1.91217C0 2.96823 0.856107 3.82434 1.91217 3.82434Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="45.8%"
            bottom="51.9%"
            left="49.47%"
            right="48.24%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024600")}
          ></Icon>
          <Icon
            width="4.25px"
            height="4.25px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 4.251932144165039,
              height: 4.251932144165039,
            }}
            paths={[
              {
                d: "M2.12597 4.25193C3.3001 4.25193 4.25193 3.3001 4.25193 2.12597C4.25193 0.951827 3.3001 0 2.12597 0C0.951827 0 0 0.951827 0 2.12597C0 3.3001 0.951827 4.25193 2.12597 4.25193Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="17.52%"
            bottom="79.92%"
            left="93.92%"
            right="3.54%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024601")}
          ></Icon>
          <Icon
            width="3.82px"
            height="3.82px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 4.676187210085118,
              height: 4.676187210086937,
            }}
            paths={[
              {
                d: "M1.90905 3.81809C2.96338 3.81809 3.81809 2.96338 3.81809 1.90905C3.81809 0.854709 2.96338 0 1.90905 0C0.854709 0 0 0.854709 0 1.90905C0 2.96338 0.854709 3.81809 1.90905 3.81809Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="31.28%"
            bottom="66.42%"
            left="36.85%"
            right="60.87%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024602")}
          ></Icon>
          <Icon
            width="5.08px"
            height="5.08px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 5.079257488250732,
              height: 5.079257488250732,
            }}
            paths={[
              {
                d: "M2.53963 5.07926C3.94223 5.07926 5.07926 3.94223 5.07926 2.53963C5.07926 1.13703 3.94223 0 2.53963 0C1.13703 0 0 1.13703 0 2.53963C0 3.94223 1.13703 5.07926 2.53963 5.07926Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="12.84%"
            bottom="84.11%"
            left="61.12%"
            right="35.84%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024603")}
          ></Icon>
          <Icon
            width="3.91px"
            height="3.13px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.907453775405884,
              height: 3.1257705688476562,
            }}
            paths={[
              {
                d: "M1.95373 3.12577C3.03274 3.12577 3.90745 2.42604 3.90745 1.56289C3.90745 0.699728 3.03274 0 1.95373 0C0.874713 0 0 0.699728 0 1.56289C0 2.42604 0.874713 3.12577 1.95373 3.12577Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="51.69%"
            bottom="46.43%"
            left="106.18%"
            right="-8.52%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024604")}
          ></Icon>
          <Icon
            width="7.95px"
            height="7.95px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 9.732496106536928,
              height: 9.732496106538747,
            }}
            paths={[
              {
                d: "M3.97327 7.94655C6.16765 7.94655 7.94655 6.16765 7.94655 3.97327C7.94655 1.7789 6.16765 0 3.97327 0C1.7789 0 0 1.7789 0 3.97327C0 6.16765 1.7789 7.94655 3.97327 7.94655Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="22.82%"
            bottom="72.4%"
            left="77.52%"
            right="17.72%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024605")}
          ></Icon>
          <Icon
            width="135.09px"
            height="50.17px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 135.0906219482422,
              height: 50.17472839355469,
            }}
            paths={[
              {
                d: "M131.548 0L131.599 0C131.902 4.28821 135.091 4.35403 135.091 4.35403C135.091 4.35403 131.574 4.42273 131.574 9.37755C131.574 4.42273 128.057 4.35403 128.057 4.35403C128.057 4.35403 131.245 4.28821 131.548 0ZM3.09694 41.6874L3.14235 41.6874C3.41092 45.5685 6.24049 45.6283 6.24049 45.6283C6.24049 45.6283 3.12025 45.6903 3.12025 50.1747C3.12025 45.6903 0 45.6283 0 45.6283C0 45.6283 2.82837 45.5685 3.09694 41.6874Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="46.13%"
            bottom="23.68%"
            left="35.07%"
            right="-16.01%"
            {...getOverrideProps(overrides, "Vector763024606")}
          ></Icon>
          <Icon
            width="32.61px"
            height="32.61px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 32.61210632324219,
              height: 32.61229705810547,
            }}
            paths={[
              {
                d: "M0.000216497 16.1823L-3.72313 16.1539L-3.72318 16.1631L0.000216497 16.1823ZM16.3884 0.000212421L16.4073 -3.72318L16.4072 -3.72318L16.3884 0.000212421ZM16.3065 32.6123L16.2975 36.3357L16.3065 36.3357L16.3065 32.6123ZM3.72355 16.2107C3.77638 9.27409 9.43296 3.68857 16.3696 3.72361L16.4072 -3.72318C5.36516 -3.77895 -3.63902 5.11228 -3.72312 16.1539L3.72355 16.2107ZM16.3695 3.72361C23.3063 3.75883 28.906 9.40114 28.8886 16.3377L36.3355 16.3564C36.3632 5.31433 27.4492 -3.66712 16.4073 -3.72318L16.3695 3.72361ZM28.8886 16.3377C28.8712 23.2745 23.2429 28.8889 16.3065 28.8889L16.3065 36.3357C27.3488 36.3357 36.3078 27.3984 36.3355 16.3564L28.8886 16.3377ZM16.3155 28.8889C14.655 28.8849 13.0116 28.5533 11.4794 27.9131L8.60835 34.7842C11.0444 35.8021 13.6574 36.3294 16.2975 36.3357L16.3155 28.8889ZM11.4794 27.9131C9.94729 27.2729 8.55653 26.3367 7.38681 25.1581L2.10121 30.4039C3.96102 32.2778 6.1723 33.7663 8.60835 34.7842L11.4794 27.9131ZM7.38681 25.1581C6.2171 23.9795 5.29143 22.5817 4.66283 21.0447L-2.22984 23.8638C-1.23039 26.3075 0.241396 28.53 2.10121 30.4039L7.38681 25.1581ZM4.66283 21.0447C4.03424 19.5078 3.71507 17.8619 3.72361 16.2015L-3.72318 16.1631C-3.73677 18.8033 -3.22929 21.4201 -2.22984 23.8638L4.66283 21.0447Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 7,
              },
              {
                d: "M0.000216497 16.1823C0.0686798 7.19318 7.39906 -0.0451896 16.3884 0.000212421C25.3778 0.0458546 32.6346 7.35774 32.6121 16.3471C32.5895 25.3364 25.2959 32.6123 16.3065 32.6123C14.1562 32.6071 12.028 32.1777 10.0439 31.3486C8.05979 30.5196 6.25877 29.3072 4.74401 27.781C3.22925 26.2547 2.03052 24.4446 1.2165 22.4543C0.402471 20.464 -0.0108504 18.3326 0.000216497 16.1823Z",
                fill: "rgba(71,160,80,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="18.93%"
            bottom="61.44%"
            left="58.02%"
            right="22.44%"
            {...getOverrideProps(overrides, "Vector763024607")}
          ></Icon>
          <Icon
            width="65.22px"
            height="24.46px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 65.22415161132812,
              height: 24.45918083190918,
            }}
            paths={[
              {
                d: "M0 20.3826L-3.72346 20.3826L-3.72343 20.3934L0 20.3826ZM0 16.306L-3.72344 16.2951L-3.72344 16.306L0 16.306ZM16.306 0L16.306 -3.72346L16.2951 -3.72343L16.306 0ZM48.9181 0L48.9291 -3.72344L48.9181 -3.72344L48.9181 0ZM65.2242 16.306L68.9476 16.306L68.9476 16.2951L65.2242 16.306ZM65.2242 20.3826L68.9476 20.3934L68.9476 20.3826L65.2242 20.3826ZM61.1476 24.4592L61.1476 28.1826L61.1587 28.1826L61.1476 24.4592ZM4.07657 24.4592L4.06543 28.1826L4.07657 28.1826L4.07657 24.4592ZM3.72344 20.3826L3.72344 16.306L-3.72344 16.306L-3.72344 20.3826L3.72344 20.3826ZM3.72343 16.317C3.74384 9.37019 9.37019 3.74384 16.317 3.72343L16.2951 -3.72343C5.25261 -3.69099 -3.69099 5.25261 -3.72343 16.2951L3.72343 16.317ZM16.306 3.72344L48.9181 3.72344L48.9181 -3.72344L16.306 -3.72344L16.306 3.72344ZM48.9072 3.72343C55.854 3.74384 61.4803 9.37019 61.5007 16.317L68.9476 16.2951C68.9151 5.25261 59.9716 -3.69099 48.9291 -3.72343L48.9072 3.72343ZM61.5007 16.306L61.5007 20.3826L68.9476 20.3826L68.9476 16.306L61.5007 16.306ZM61.5007 20.3719C61.5001 20.5722 61.3378 20.7352 61.1365 20.7358L61.1587 28.1826C65.4548 28.1698 68.9352 24.6904 68.9476 20.3934L61.5007 20.3719ZM61.1476 20.7357L4.07657 20.7357L4.07657 28.1826L61.1476 28.1826L61.1476 20.7357ZM4.08771 20.7358C3.88632 20.7352 3.72401 20.5722 3.72343 20.3719L-3.72343 20.3934C-3.71103 24.6905 -0.230615 28.1698 4.06543 28.1826L4.08771 20.7358Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 7,
              },
              {
                d: "M0 20.3826L0 16.306C0.0264244 7.3114 7.3114 0.0264244 16.306 0L48.9181 0C57.9128 0.0264244 65.1977 7.3114 65.2242 16.306L65.2242 20.3826C65.2177 22.6313 63.3963 24.4525 61.1476 24.4592L4.07657 24.4592C1.82785 24.4525 0.006486 22.6313 0 20.3826Z",
                fill: "rgba(71,160,80,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="48.29%"
            bottom="36.99%"
            left="48.26%"
            right="12.67%"
            {...getOverrideProps(overrides, "Vector763024608")}
          ></Icon>
          <Icon
            width="41.74px"
            height="72px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 41.74340057373047,
              height: 71.9981918334961,
            }}
            paths={[
              {
                d: "M13.0314 2.63287C14.4855 1.17878 14.4855 -1.17878 13.0314 -2.63287C11.5773 -4.08697 9.21972 -4.08697 7.76562 -2.63287L13.0314 2.63287ZM3.29128 7.10721L0.65841 4.47434C-0.0398713 5.17262 -0.432162 6.11969 -0.432162 7.10721C-0.432162 8.09473 -0.0398711 9.0418 0.65841 9.74009L3.29128 7.10721ZM7.76562 16.8473C9.21972 18.3014 11.5773 18.3014 13.0314 16.8473C14.4855 15.3932 14.4855 13.0356 13.0314 11.5816L7.76562 16.8473ZM34.353 -2.63287C32.8989 -4.08697 30.5414 -4.08697 29.0873 -2.63287C27.6332 -1.17878 27.6332 1.17878 29.0873 2.63287L34.353 -2.63287ZM38.8273 7.10721L41.4602 9.74009C42.1585 9.0418 42.5508 8.09473 42.5508 7.10721C42.5508 6.11969 42.1585 5.17262 41.4602 4.47434L38.8273 7.10721ZM29.0873 11.5816C27.6332 13.0356 27.6332 15.3932 29.0873 16.8473C30.5414 18.3014 32.8989 18.3014 34.353 16.8473L29.0873 11.5816ZM0 30.6468C-2.0564 30.6468 -3.72344 32.3139 -3.72344 34.3703C-3.72344 36.4267 -2.0564 38.0937 0 38.0937L0 30.6468ZM41.7434 38.0937C43.7998 38.0937 45.4668 36.4267 45.4668 34.3703C45.4668 32.3139 43.7998 30.6468 41.7434 30.6468L41.7434 38.0937ZM0 49.4608C-2.0564 49.4608 -3.72344 51.1278 -3.72344 53.1842C-3.72344 55.2406 -2.0564 56.9077 0 56.9077L0 49.4608ZM41.7434 56.9077C43.7998 56.9077 45.4668 55.2406 45.4668 53.1842C45.4668 51.1278 43.7998 49.4608 41.7434 49.4608L41.7434 56.9077ZM0 68.2747C-2.0564 68.2747 -3.72344 69.9418 -3.72344 71.9982C-3.72344 74.0546 -2.0564 75.7216 0 75.7216L0 68.2747ZM41.7434 75.7216C43.7998 75.7216 45.4668 74.0546 45.4668 71.9982C45.4668 69.9418 43.7998 68.2747 41.7434 68.2747L41.7434 75.7216ZM7.76562 -2.63287L0.65841 4.47434L5.92416 9.74008L13.0314 2.63287L7.76562 -2.63287ZM0.65841 9.74009L7.76562 16.8473L13.0314 11.5816L5.92415 4.47434L0.65841 9.74009ZM29.0873 2.63287L36.1945 9.74009L41.4602 4.47434L34.353 -2.63287L29.0873 2.63287ZM36.1945 4.47434L29.0873 11.5816L34.353 16.8473L41.4602 9.74009L36.1945 4.47434ZM0 38.0937L41.7434 38.0937L41.7434 30.6468L0 30.6468L0 38.0937ZM0 56.9077L41.7434 56.9077L41.7434 49.4608L0 49.4608L0 56.9077ZM0 75.7216L41.7434 75.7216L41.7434 68.2747L0 68.2747L0 75.7216Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 7,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="18.98%"
            bottom="37.7%"
            left="12.85%"
            right="62.14%"
            {...getOverrideProps(overrides, "Vector763024609")}
          ></Icon>
          <Flex
            gap="4.454494953155518px"
            direction="column"
            width="136.53px"
            height="35.19px"
            justifyContent="space-between"
            alignItems="flex-start"
            overflow="hidden"
            position="absolute"
            top="73.73%"
            bottom="5.1%"
            left="9.71%"
            right="8.49%"
            border="0.45px SOLID rgba(71,160,80,1)"
            borderRadius="1.7817977666854858px"
            padding="6.236292272806168px 10.822301298379898px 6.236292272806168px 10.822301298379898px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 427318909763024610")}
          >
            <Flex
              gap="3.1181461811065674px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318911763024611")}
            >
              <Text
                fontFamily="Inter"
                fontSize="14.699832916259766px"
                fontWeight="700"
                color="rgba(0,0,0,1)"
                lineHeight="22.04974937438965px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="98%"
                {...getOverrideProps(overrides, "98%")}
              ></Text>
              <Flex
                gap="4.454494953155518px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318934763024613")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="8.908989906311035px"
                  fontWeight="600"
                  color="rgba(0,0,0,1)"
                  lineHeight="9.666254043579102px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Match"
                  {...getOverrideProps(overrides, "Match763024614")}
                ></Text>
                <Flex
                  gap="4.454494953155518px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  borderRadius="3.1181461811065674px"
                  padding="0.8908988833427429px 3.5635955333709717px 0.8908988833427429px 3.5635955333709717px"
                  backgroundColor="rgba(71,160,80,1)"
                  {...getOverrideProps(overrides, "Frame 427318910763024615")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="8.908989906311035px"
                    fontWeight="600"
                    color="rgba(255,255,255,1)"
                    lineHeight="9.666254043579102px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Excellent"
                    {...getOverrideProps(overrides, "Excellent")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </View>
        <View
          padding="0px 0px 0px 0px"
          width="16.29px"
          height="24.38px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="207.4px"
          left="113.65px"
          transformOrigin="top left"
          transform="rotate(-54.25deg)"
          {...getOverrideProps(overrides, "Group 135")}
        >
          <Icon
            width="15.59px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 15.038227691587963,
              height: 4.096972750980058,
            }}
            paths={[
              {
                d: "M0.64943 -1.29886C0.29076 -1.29886 0 -1.0081 0 -0.64943C0 -0.29076 0.29076 0 0.64943 0L0.64943 -1.29886ZM14.9369 0C15.2956 0 15.5863 -0.29076 15.5863 -0.64943C15.5863 -1.0081 15.2956 -1.29886 14.9369 -1.29886L14.9369 0ZM0.64943 0L14.9369 0L14.9369 -1.29886L0.64943 -1.29886L0.64943 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="100%"
            left="23.72%"
            right="-19.37%"
            transformOrigin="top left"
            transform="rotate(39.01deg)"
            {...getOverrideProps(overrides, "Line 9763024618")}
          ></Icon>
          <Icon
            width="15.59px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 10.97500056464196,
              height: 11.067196240477642,
            }}
            paths={[
              {
                d: "M0.64943 -1.29886C0.29076 -1.29886 0 -1.0081 0 -0.64943C0 -0.29076 0.29076 0 0.64943 0L0.64943 -1.29886ZM14.9369 0C15.2956 0 15.5863 -0.29076 15.5863 -0.64943C15.5863 -1.0081 15.2956 -1.29886 14.9369 -1.29886L14.9369 0ZM0.64943 0L14.9369 0L14.9369 -1.29886L0.64943 -1.29886L0.64943 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="49.33%"
            bottom="50.67%"
            left="5.52%"
            right="-1.18%"
            transformOrigin="top left"
            transform="rotate(9.01deg)"
            {...getOverrideProps(overrides, "Line 10763024619")}
          ></Icon>
          <Icon
            width="15.59px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.9710314511085016,
              height: 15.071973315622017,
            }}
            paths={[
              {
                d: "M0.64943 -1.29886C0.29076 -1.29886 0 -1.0081 0 -0.64943C0 -0.29076 0.29076 0 0.64943 0L0.64943 -1.29886ZM14.9369 0C15.2956 0 15.5863 -0.29076 15.5863 -0.64943C15.5863 -1.0081 15.2956 -1.29886 14.9369 -1.29886L14.9369 0ZM0.64943 0L14.9369 0L14.9369 -1.29886L0.64943 -1.29886L0.64943 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="100%"
            bottom="0%"
            left="0%"
            right="4.35%"
            transformOrigin="top left"
            transform="rotate(-20.99deg)"
            {...getOverrideProps(overrides, "Line 11763024620")}
          ></Icon>
        </View>
        <View
          padding="0px 0px 0px 0px"
          width="16.29px"
          height="24.38px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="17.24px"
          left="326.47px"
          transformOrigin="top left"
          transform="rotate(135deg)"
          {...getOverrideProps(overrides, "Group 136")}
        >
          <Icon
            width="15.59px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 15.501119846385336,
              height: 1.62750613895696,
            }}
            paths={[
              {
                d: "M0.64943 -1.29886C0.29076 -1.29886 0 -1.0081 0 -0.64943C0 -0.29076 0.29076 0 0.64943 0L0.64943 -1.29886ZM14.9369 0C15.2956 0 15.5863 -0.29076 15.5863 -0.64943C15.5863 -1.0081 15.2956 -1.29886 14.9369 -1.29886L14.9369 0ZM0.64943 0L14.9369 0L14.9369 -1.29886L0.64943 -1.29886L0.64943 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="100%"
            left="23.71%"
            right="-19.37%"
            transformOrigin="top left"
            transform="rotate(39.01deg)"
            {...getOverrideProps(overrides, "Line 9763024622")}
          ></Icon>
          <Icon
            width="15.59px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 12.610609824654603,
              height: 9.160021291409066,
            }}
            paths={[
              {
                d: "M0.64943 -1.29886C0.29076 -1.29886 0 -1.0081 0 -0.64943C0 -0.29076 0.29076 0 0.64943 0L0.64943 -1.29886ZM14.9369 0C15.2956 0 15.5863 -0.29076 15.5863 -0.64943C15.5863 -1.0081 15.2956 -1.29886 14.9369 -1.29886L14.9369 0ZM0.64943 0L14.9369 0L14.9369 -1.29886L0.64943 -1.29886L0.64943 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="49.33%"
            bottom="50.67%"
            left="5.53%"
            right="-1.18%"
            transformOrigin="top left"
            transform="rotate(9.01deg)"
            {...getOverrideProps(overrides, "Line 10763024623")}
          ></Icon>
          <Icon
            width="15.59px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 6.341098090466403,
              height: 14.238116195865587,
            }}
            paths={[
              {
                d: "M0.64943 -1.29886C0.29076 -1.29886 0 -1.0081 0 -0.64943C0 -0.29076 0.29076 0 0.64943 0L0.64943 -1.29886ZM14.9369 0C15.2956 0 15.5863 -0.29076 15.5863 -0.64943C15.5863 -1.0081 15.2956 -1.29886 14.9369 -1.29886L14.9369 0ZM0.64943 0L14.9369 0L14.9369 -1.29886L0.64943 -1.29886L0.64943 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="100%"
            bottom="0%"
            left="0%"
            right="4.35%"
            transformOrigin="top left"
            transform="rotate(-20.99deg)"
            {...getOverrideProps(overrides, "Line 11763024624")}
          ></Icon>
        </View>
        <View
          width="122.74px"
          height="129.24px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          position="absolute"
          top="64.94px"
          left="0px"
          border="0.65px SOLID rgba(225,225,225,1)"
          borderRadius="5.195441246032715px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "389 1")}
        >
          <Icon
            width="159px"
            height="106px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 158.99530029296875,
              height: 105.99686431884766,
            }}
            paths={[]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="17.98%"
            left="0%"
            right="-29.54%"
            {...getOverrideProps(overrides, "Vector763024626")}
          ></Icon>
          <Icon
            width="19.71px"
            height="14.35px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 19.712060928344727,
              height: 14.347073554992676,
            }}
            paths={[
              {
                d: "M6.46281 12.8306C11.9047 16.0923 19.7121 13.0772 19.7121 13.0772C19.7121 13.0772 18.6911 4.7752 13.2461 1.51739C7.80402 -1.74413 0 1.26723 0 1.26723C0 1.26723 1.02075 9.56908 6.46281 12.8306Z",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="56.88%"
            bottom="32.02%"
            left="13.52%"
            right="70.42%"
            {...getOverrideProps(overrides, "Vector763024627")}
          ></Icon>
          <Icon
            width="4.55px"
            height="4.55px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 4.548326015472412,
              height: 4.548323154449463,
            }}
            paths={[
              {
                d: "M2.27416 4.54832C3.53015 4.54832 4.54833 3.53015 4.54833 2.27416C4.54833 1.01817 3.53015 0 2.27416 0C1.01817 0 0 1.01817 0 2.27416C0 3.53015 1.01817 4.54832 2.27416 4.54832Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="27.75%"
            bottom="68.73%"
            left="50.91%"
            right="45.38%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024628")}
          ></Icon>
          <Icon
            width="5.12px"
            height="5.12px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 5.116825580596924,
              height: 5.116825580596924,
            }}
            paths={[
              {
                d: "M2.55841 5.11683C3.97138 5.11683 5.11683 3.97139 5.11683 2.55842C5.11683 1.14544 3.97138 0 2.55841 0C1.14544 0 0 1.14544 0 2.55842C0 3.97139 1.14544 5.11683 2.55841 5.11683Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="39.45%"
            bottom="56.59%"
            left="40.35%"
            right="55.48%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024629")}
          ></Icon>
          <Icon
            width="2.56px"
            height="2.56px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.558411121368408,
              height: 2.558411121368408,
            }}
            paths={[
              {
                d: "M1.27921 2.55841C1.98569 2.55841 2.55841 1.98569 2.55841 1.27921C2.55841 0.57272 1.98569 0 1.27921 0C0.57272 0 0 0.57272 0 1.27921C0 1.98569 0.57272 2.55841 1.27921 2.55841Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="67.78%"
            bottom="30.24%"
            left="97.88%"
            right="0.04%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024630")}
          ></Icon>
          <Icon
            width="3.7px"
            height="3.7px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.695404052734375,
              height: 3.695404052734375,
            }}
            paths={[
              {
                d: "M1.8477 3.6954C2.86816 3.6954 3.6954 2.86816 3.6954 1.8477C3.6954 0.827244 2.86816 0 1.8477 0C0.827244 0 0 0.827244 0 1.8477C0 2.86816 0.827244 3.6954 1.8477 3.6954Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="57.06%"
            bottom="40.08%"
            left="25.49%"
            right="71.5%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024631")}
          ></Icon>
          <Icon
            width="2.81px"
            height="2.81px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.8124501705169678,
              height: 2.8124501705169678,
            }}
            paths={[
              {
                d: "M1.40623 2.81245C2.18286 2.81245 2.81245 2.18286 2.81245 1.40623C2.81245 0.629588 2.18286 0 1.40623 0C0.629588 0 0 0.629588 0 1.40623C0 2.18286 0.629588 2.81245 1.40623 2.81245Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="43.32%"
            bottom="54.51%"
            left="49.47%"
            right="48.24%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024632")}
          ></Icon>
          <Icon
            width="3.13px"
            height="3.13px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.1269073486328125,
              height: 3.1269073486328125,
            }}
            paths={[
              {
                d: "M1.56345 3.12691C2.42693 3.12691 3.12691 2.42693 3.12691 1.56345C3.12691 0.699982 2.42693 0 1.56345 0C0.699982 0 0 0.699982 0 1.56345C0 2.42693 0.699982 3.12691 1.56345 3.12691Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="16.57%"
            bottom="81.01%"
            left="93.92%"
            right="3.54%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024633")}
          ></Icon>
          <Icon
            width="2.81px"
            height="2.81px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.4389081709505263,
              height: 3.4389081709523452,
            }}
            paths={[
              {
                d: "M1.40393 2.80786C2.1793 2.80786 2.80786 2.1793 2.80786 1.40393C2.80786 0.62856 2.1793 0 1.40393 0C0.62856 0 0 0.62856 0 1.40393C0 2.1793 0.62856 2.80786 1.40393 2.80786Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="29.58%"
            bottom="68.24%"
            left="36.85%"
            right="60.87%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024634")}
          ></Icon>
          <Icon
            width="3.74px"
            height="3.74px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 3.7353293895721436,
              height: 3.7353293895721436,
            }}
            paths={[
              {
                d: "M1.86766 3.73533C2.89915 3.73533 3.73533 2.89915 3.73533 1.86766C3.73533 0.836182 2.89915 0 1.86766 0C0.836182 0 0 0.836182 0 1.86766C0 2.89915 0.836182 3.73533 1.86766 3.73533Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="12.14%"
            bottom="84.97%"
            left="61.12%"
            right="35.84%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024635")}
          ></Icon>
          <Icon
            width="2.87px"
            height="2.3px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 2.87357497215271,
              height: 2.2987184524536133,
            }}
            paths={[
              {
                d: "M1.43679 2.29872C2.2303 2.29872 2.87357 1.78413 2.87357 1.14936C2.87357 0.514586 2.2303 0 1.43679 0C0.643272 0 0 0.514586 0 1.14936C0 1.78413 0.643272 2.29872 1.43679 2.29872Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="48.88%"
            bottom="49.34%"
            left="106.18%"
            right="-8.52%"
            transformOrigin="top left"
            transform="rotate(180deg)"
            {...getOverrideProps(overrides, "Vector763024636")}
          ></Icon>
          <Icon
            width="5.84px"
            height="5.84px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 7.157360884044465,
              height: 7.157360884044465,
            }}
            paths={[
              {
                d: "M2.92198 5.84396C4.53575 5.84396 5.84396 4.53575 5.84396 2.92198C5.84396 1.30822 4.53575 0 2.92198 0C1.30822 0 0 1.30822 0 2.92198C0 4.53575 1.30822 5.84396 2.92198 5.84396Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="21.58%"
            bottom="73.89%"
            left="77.52%"
            right="17.72%"
            transformOrigin="top left"
            transform="rotate(75deg)"
            {...getOverrideProps(overrides, "Vector763024637")}
          ></Icon>
          <Icon
            width="99.35px"
            height="36.9px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 99.3468017578125,
              height: 36.898921966552734,
            }}
            paths={[
              {
                d: "M96.7414 0L96.779 0C97.0016 3.15358 99.3468 3.20199 99.3468 3.20199C99.3468 3.20199 96.7606 3.25251 96.7606 6.89633C96.7606 3.25251 94.1745 3.20199 94.1745 3.20199C94.1745 3.20199 96.5188 3.15358 96.7414 0ZM2.27752 30.6573L2.31091 30.6573C2.50842 33.5114 4.58931 33.5554 4.58931 33.5554C4.58931 33.5554 2.29466 33.601 2.29466 36.8989C2.29466 33.601 0 33.5554 0 33.5554C0 33.5554 2.08001 33.5114 2.27752 30.6573Z",
                fill: "rgba(225,228,229,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="43.63%"
            bottom="27.82%"
            left="35.07%"
            right="-16.01%"
            {...getOverrideProps(overrides, "Vector763024638")}
          ></Icon>
          <Icon
            width="23.98px"
            height="23.98px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 23.98322296142578,
              height: 23.983362197875977,
            }}
            paths={[
              {
                d: "M0.000159214 11.9006L-2.73802 11.8797L-2.73806 11.8865L0.000159214 11.9006ZM12.0522 0.000156216L12.0661 -2.73806L12.066 -2.73806L12.0522 0.000156216ZM11.9919 23.9834L11.9853 26.7216L11.9919 26.7216L11.9919 23.9834ZM2.73833 11.9215C2.77718 6.82024 6.93708 2.71261 12.0384 2.73837L12.066 -2.73806C3.94558 -2.77907 -2.67617 3.75961 -2.73801 11.8797L2.73833 11.9215ZM12.0383 2.73837C17.1397 2.76428 21.2578 6.91368 21.2449 12.0149L26.7214 12.0287C26.7418 3.90821 20.1864 -2.69683 12.0661 -2.73806L12.0383 2.73837ZM21.2449 12.0149C21.2321 17.1163 17.0931 21.2451 11.9919 21.2451L11.9919 26.7216C20.1125 26.7216 26.701 20.149 26.7214 12.0287L21.2449 12.0149ZM11.9985 21.2451C10.7774 21.2422 9.56882 20.9983 8.44207 20.5275L6.33065 25.5806C8.12215 26.3292 10.0437 26.7169 11.9853 26.7216L11.9985 21.2451ZM8.44207 20.5275C7.31532 20.0567 6.29254 19.3682 5.43233 18.5015L1.54525 22.3593C2.91297 23.7374 4.53916 24.8321 6.33065 25.5806L8.44207 20.5275ZM5.43233 18.5015C4.57211 17.6347 3.89136 16.6068 3.42909 15.4765L-1.63985 17.5497C-0.904841 19.3468 0.177525 20.9812 1.54525 22.3593L5.43233 18.5015ZM3.42909 15.4765C2.96681 14.3462 2.73209 13.1358 2.73838 11.9147L-2.73806 11.8865C-2.74805 13.8281 -2.37485 15.7526 -1.63985 17.5497L3.42909 15.4765Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
              {
                d: "M0.000159214 11.9006C0.0505077 5.28993 5.44133 -0.0332328 12.0522 0.000156216C18.663 0.0337219 23.9998 5.41094 23.9832 12.0218C23.9666 18.6326 18.6028 23.9834 11.9919 23.9834C10.4106 23.9795 8.84548 23.6637 7.38636 23.0541C5.92724 22.4444 4.60276 21.5528 3.48879 20.4304C2.37482 19.3079 1.49326 17.9768 0.894621 16.5131C0.29598 15.0494 -0.00797944 13.482 0.000159214 11.9006Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="17.91%"
            bottom="63.54%"
            left="58.02%"
            right="22.44%"
            {...getOverrideProps(overrides, "Vector763024639")}
          ></Icon>
          <Icon
            width="47.97px"
            height="17.99px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 47.966400146484375,
              height: 17.987491607666016,
            }}
            paths={[
              {
                d: "M0 14.9896L-2.73826 14.9896L-2.73824 14.9974L0 14.9896ZM0 11.9916L-2.73825 11.9836L-2.73825 11.9916L0 11.9916ZM11.9916 0L11.9916 -2.73826L11.9836 -2.73824L11.9916 0ZM35.9748 0L35.9828 -2.73825L35.9748 -2.73825L35.9748 0ZM47.9664 11.9916L50.7047 11.9916L50.7046 11.9836L47.9664 11.9916ZM47.9664 14.9896L50.7047 14.9974L50.7047 14.9896L47.9664 14.9896ZM44.9685 17.9875L44.9685 20.7258L44.9767 20.7257L44.9685 17.9875ZM2.99794 17.9875L2.98975 20.7257L2.99794 20.7257L2.99794 17.9875ZM2.73825 14.9896L2.73825 11.9916L-2.73825 11.9916L-2.73825 14.9896L2.73825 14.9896ZM2.73824 11.9996C2.75325 6.89092 6.89092 2.75325 11.9996 2.73824L11.9836 -2.73824C3.86281 -2.71438 -2.71438 3.86281 -2.73824 11.9836L2.73824 11.9996ZM11.9916 2.73825L35.9748 2.73825L35.9748 -2.73825L11.9916 -2.73825L11.9916 2.73825ZM35.9668 2.73824C41.0755 2.75325 45.2132 6.89092 45.2282 11.9996L50.7046 11.9836C50.6808 3.86282 44.1036 -2.71438 35.9828 -2.73824L35.9668 2.73824ZM45.2281 11.9916L45.2281 14.9896L50.7047 14.9896L50.7047 11.9916L45.2281 11.9916ZM45.2282 14.9817C45.2277 15.129 45.1084 15.2488 44.9603 15.2493L44.9767 20.7257C48.136 20.7163 50.6955 18.1576 50.7046 14.9974L45.2282 14.9817ZM44.9685 15.2492L2.99794 15.2492L2.99794 20.7257L44.9685 20.7257L44.9685 15.2492ZM3.00614 15.2493C2.85803 15.2488 2.73867 15.129 2.73824 14.9817L-2.73824 14.9974C-2.72913 18.1576 -0.169597 20.7163 2.98975 20.7257L3.00614 15.2493Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
              {
                d: "M0 14.9896L0 11.9916C0.0194328 5.37687 5.37687 0.0194328 11.9916 0L35.9748 0C42.5895 0.0194328 47.947 5.37687 47.9664 11.9916L47.9664 14.9896C47.9616 16.6433 46.6222 17.9825 44.9685 17.9875L2.99794 17.9875C1.34422 17.9825 0.00476986 16.6433 0 14.9896Z",
                fill: "rgba(179,179,179,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="45.67%"
            bottom="40.41%"
            left="48.25%"
            right="12.67%"
            {...getOverrideProps(overrides, "Vector763024640")}
          ></Icon>
          <Icon
            width="30.7px"
            height="52.95px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 30.698453903198242,
              height: 52.948081970214844,
            }}
            paths={[
              {
                d: "M9.58338 1.93624C10.6527 0.866883 10.6527 -0.866883 9.58338 -1.93624C8.51403 -3.00559 6.78026 -3.00559 5.71091 -1.93624L9.58338 1.93624ZM2.42044 5.2267L0.484201 3.29047C-0.0293215 3.80399 -0.317815 4.50047 -0.317815 5.2267C-0.317815 5.95293 -0.0293213 6.64942 0.484201 7.16294L2.42044 5.2267ZM5.71091 12.3896C6.78026 13.459 8.51403 13.459 9.58338 12.3896C10.6527 11.3203 10.6527 9.58652 9.58338 8.51717L5.71091 12.3896ZM25.2635 -1.93624C24.1941 -3.00559 22.4604 -3.00559 21.391 -1.93624C20.3217 -0.866883 20.3217 0.866883 21.391 1.93624L25.2635 -1.93624ZM28.554 5.2267L30.4902 7.16294C31.0037 6.64942 31.2922 5.95293 31.2922 5.2267C31.2922 4.50047 31.0037 3.80399 30.4902 3.29047L28.554 5.2267ZM21.391 8.51717C20.3217 9.58652 20.3217 11.3203 21.391 12.3896C22.4604 13.459 24.1941 13.459 25.2635 12.3896L21.391 8.51717ZM0 22.5379C-1.5123 22.5379 -2.73825 23.7639 -2.73825 25.2762C-2.73825 26.7885 -1.5123 28.0144 0 28.0144L0 22.5379ZM30.6985 28.0144C32.2108 28.0144 33.4367 26.7885 33.4367 25.2762C33.4367 23.7639 32.2108 22.5379 30.6985 22.5379L30.6985 28.0144ZM0 36.3739C-1.5123 36.3739 -2.73825 37.5998 -2.73825 39.1121C-2.73825 40.6244 -1.5123 41.8504 0 41.8504L0 36.3739ZM30.6985 41.8504C32.2108 41.8504 33.4367 40.6244 33.4367 39.1121C33.4367 37.5998 32.2108 36.3739 30.6985 36.3739L30.6985 41.8504ZM0 50.2098C-1.5123 50.2098 -2.73825 51.4358 -2.73825 52.9481C-2.73825 54.4604 -1.5123 55.6863 0 55.6863L0 50.2098ZM30.6985 55.6863C32.2108 55.6863 33.4367 54.4604 33.4367 52.9481C33.4367 51.4358 32.2108 50.2098 30.6985 50.2098L30.6985 55.6863ZM5.71091 -1.93624L0.484201 3.29047L4.35667 7.16294L9.58338 1.93624L5.71091 -1.93624ZM0.484201 7.16294L5.71091 12.3896L9.58338 8.51717L4.35667 3.29047L0.484201 7.16294ZM21.391 1.93624L26.6177 7.16294L30.4902 3.29047L25.2635 -1.93624L21.391 1.93624ZM26.6177 3.29047L21.391 8.51717L25.2635 12.3896L30.4902 7.16294L26.6177 3.29047ZM0 28.0144L30.6985 28.0144L30.6985 22.5379L0 22.5379L0 28.0144ZM0 41.8504L30.6985 41.8504L30.6985 36.3739L0 36.3739L0 41.8504ZM0 55.6863L30.6985 55.6863L30.6985 50.2098L0 50.2098L0 55.6863Z",
                stroke: "rgba(179,179,179,1)",
                fillRule: "nonzero",
                strokeLinejoin: "round",
                strokeWidth: 5,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="17.95%"
            bottom="41.08%"
            left="12.85%"
            right="62.14%"
            {...getOverrideProps(overrides, "Vector763024641")}
          ></Icon>
          <Flex
            gap="3.2758734226226807px"
            direction="column"
            width="100.41px"
            height="25.88px"
            justifyContent="space-between"
            alignItems="center"
            overflow="hidden"
            position="absolute"
            top="69.73%"
            bottom="10.25%"
            left="9.7%"
            right="8.49%"
            border="0.33px SOLID rgba(71,160,80,1)"
            borderRadius="1.3103493452072144px"
            padding="4.586222916841507px 7.958813458681107px 4.586222916841507px 7.958813458681107px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 427318909763024642")}
          >
            <Flex
              gap="2.2931113243103027px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318911763024643")}
            >
              <Text
                fontFamily="Inter"
                fontSize="10.810383796691895px"
                fontWeight="700"
                color="rgba(0,0,0,1)"
                lineHeight="16.215576171875px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="88%"
                {...getOverrideProps(overrides, "88%")}
              ></Text>
              <Flex
                gap="3.2758734226226807px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318934763024645")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="6.551746845245361px"
                  fontWeight="600"
                  color="rgba(0,0,0,1)"
                  lineHeight="7.108645439147949px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Match"
                  {...getOverrideProps(overrides, "Match763024646")}
                ></Text>
                <Flex
                  gap="3.2758734226226807px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  borderRadius="2.2931113243103027px"
                  padding="0.6551746726036072px 2.6206986904144287px 0.6551746726036072px 2.6206986904144287px"
                  backgroundColor="rgba(71,160,80,1)"
                  {...getOverrideProps(overrides, "Frame 427318910763024647")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="6.551746845245361px"
                    fontWeight="600"
                    color="rgba(255,255,255,1)"
                    lineHeight="7.108645439147949px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Great"
                    {...getOverrideProps(overrides, "Great763024648")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </View>
      </Flex>
      <Flex
        gap="55px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="21px 20px 40px 20px"
        {...getOverrideProps(overrides, "ProcessMObile")}
      >
        <Flex
          gap="16px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Process Left")}
        >
          <Flex
            gap="24px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 110")}
          >
            <Text
              fontFamily="Inter"
              fontSize="32px"
              fontWeight="700"
              color="rgba(30,27,27,1)"
              lineHeight="60px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="42px"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Everyone Agrees. "
              {...getOverrideProps(overrides, "Everyone Agrees.\u00A0")}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(31,31,31,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="-0.21px"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="You’re about to experience an innovative, new roadmap so you discover the job you’ll treasure."
              {...getOverrideProps(
                overrides,
                "You\u2019re about to experience an innovative, new roadmap so you discover the job you\u2019ll treasure."
              )}
            ></Text>
          </Flex>
          <Flex
            gap="24px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464351")}
          >
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(13,26,38,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="This Is Job Search Done Right. "
              {...getOverrideProps(overrides, "This Is Job Search Done Right.")}
            ></Text>
            <Flex
              gap="14px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464105")}
            >
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464114")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check763024709")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Effortless, Rewarding, Fast"
                  {...getOverrideProps(
                    overrides,
                    "Effortless, Rewarding, Fast"
                  )}
                ></Text>
              </Flex>
              <Icon
                width="unset"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 362, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L362 0.5L362 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                {...getOverrideProps(overrides, "Line 3")}
              ></Icon>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464115")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check763024713")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We Search - You Approve "
                  {...getOverrideProps(overrides, "We Search - You Approve")}
                ></Text>
              </Flex>
              <Icon
                width="unset"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 362, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L362 0.5L362 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                {...getOverrideProps(overrides, "Line 2")}
              ></Icon>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464116")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check763024717")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Results That You Can Trust "
                  {...getOverrideProps(
                    overrides,
                    "Results That You Can Trust\u00A0"
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
